module.exports = new __parcel__URL__("image-product-2-thumbnail.273df9ad.jpg").toString();